// ** React Imports
import { useState, ElementType, ChangeEvent, SyntheticEvent, useEffect } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Select from '@mui/material/Select'
import Dialog from '@mui/material/Dialog'
import Divider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'
import Checkbox from '@mui/material/Checkbox'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import InputLabel from '@mui/material/InputLabel'
import CardHeader from '@mui/material/CardHeader'
import FormControl from '@mui/material/FormControl'
import CardContent from '@mui/material/CardContent'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import FormHelperText from '@mui/material/FormHelperText'
import InputAdornment from '@mui/material/InputAdornment'
import Button, { ButtonProps } from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormGroup from '@mui/material/FormGroup'

// ** Third Party Imports
import { useForm, Controller } from 'react-hook-form'

import moment from 'moment'
import 'moment/locale/id'
import { Alert, AlertTitle, DialogTitle, Fab, IconButton, OutlinedInput, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import { TabContext, TabList, TabPanel } from '@mui/lab'
import axios from 'axios'
import Swal from 'sweetalert2'

import { useSearchParams, useNavigate } from "react-router-dom";

import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';
import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import appInfo from '../../../../configs/app-info';
import { getDoctag, getGudang, getProses } from '../../../../api/helper';
import { useToast } from '../../../../components/ToastProvider';
import { reconcileInvoice } from './reconciliation';

// Fungsi untuk format angka jadi ribuan
const formatNumber = (val: any) => {
    const num = Number(val);
    if (isNaN(num)) return '';
    return num.toLocaleString('id-ID');
};

const terbilang = (nominal: number) => {
    if (isNaN(nominal) || nominal < 0) return 'Nominal tidak valid'

    const satuan = ['', 'satu', 'dua', 'tiga', 'empat', 'lima', 'enam', 'tujuh', 'delapan', 'sembilan', 'sepuluh', 'sebelas']

    const penyebut = (n: number): string => {
        if (n < 12) return satuan[n]
        if (n < 20) return `${penyebut(n - 10)} belas`
        if (n < 100) return `${penyebut(Math.floor(n / 10))} puluh ${penyebut(n % 10)}`
        if (n < 200) return `seratus ${penyebut(n - 100)}`
        if (n < 1000) return `${penyebut(Math.floor(n / 100))} ratus ${penyebut(n % 100)}`
        if (n < 2000) return `seribu ${penyebut(n - 1000)}`
        if (n < 1000000) return `${penyebut(Math.floor(n / 1000))} ribu ${penyebut(n % 1000)}`
        if (n < 1000000000) return `${penyebut(Math.floor(n / 1000000))} juta ${penyebut(n % 1000000)}`
        if (n < 1000000000000) return `${penyebut(Math.floor(n / 1000000000))} miliar ${penyebut(n % 1000000000)}`
        return 'Angka terlalu besar'
    }

    const result = penyebut(Math.floor(nominal))?.replace(/\s+/g, ' ').trim() || ''

    return `${result} rupiah`
}

const Add = () => {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const pbsupplier_id = searchParams.get('pbsupplier_id');

    // ** State
    const [tglDokumen, setTglDokumen] = useState<string>(moment().format('YYYY-MM-DD'))

    const [tagihan, setTagihan] = useState<any>(null)
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [valueTabs, setValueTabs] = useState<string>('1')

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    // build initial arrays
    let initialPengurangan: any[] = [
        {
            accakun_id: 4000011,
            akun: 'PENDAPATAN LAINNYA',
            total: 0,
            keterangan: '',
            petunjuk: 'SALAH HARGA (-)'
        },
        {
            accakun_id: 800005,
            akun: 'PENDAPATAN SELISIH KURS',
            total: 0,
            keterangan: '',
            petunjuk: 'SELISIH KURS'
        },
        {
            accakun_id: 700099,
            akun: 'DISKON PEMBELIAN',
            total: 0,
            keterangan: '',
            petunjuk: 'DISKON PEMBELIAN'
        },
    ]

    let initialPenambahan: any[] = [
        {
            accakun_id: 800099,
            akun: 'BIAYA PEMBELIAN LAI LAIN',
            total: 0,
            keterangan: '',
            petunjuk: 'SALAH HARGA (+)'
        },
        {
            accakun_id: 800005,
            akun: 'BIAYA SELISIH KURS',
            total: 0,
            keterangan: '',
            petunjuk: 'SELISIH KURS'
        },
        {
            accakun_id: 510204,
            akun: 'BIAYA ANGKUT DAN EXPEDISI PEMBELIAN',
            total: 0,
            keterangan: '',
            petunjuk: 'JASA ANGKUTAN'
        },
        {
            accakun_id: 622005,
            akun: 'BIAYA SUPPLIES KOMPUTER, ATK & METERAI',
            total: 0,
            keterangan: '',
            petunjuk: 'ATK & METERAI'
        },
    ]

    const [listDataPengurangan, setListDataPengurangan] = useState<any[]>(initialPengurangan)
    const [listDataPenambahan, setListDataPenambahan] = useState<any[]>(initialPenambahan)
    const [listSupplier, setListSupplier] = useState<any[]>([])


    const convertDate = (pdate: Date) => {
        const yyyy = pdate.getFullYear()
        let mm = pdate.getMonth() + 1
        let dd = pdate.getDate()

        let sdd: string = dd.toString()
        let smm: string = mm.toString()

        if (dd < 10) sdd = '0' + dd
        if (mm < 10) smm = '0' + mm

        const formatted = sdd + '-' + smm + '-' + yyyy

        return formatted
    }

    const getSupplier = () => {
        const url = apiUrl.apiUrl + '/acc/invoice-receipt/get-supplier'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    const supplier = data.find((item: any) => item.id === Number(pbsupplier_id))
                    if (supplier) {
                        setValue('supplier_id', supplier.id)
                        setValue('supplier_name', supplier.nama)
                        setValue('alamat', supplier.alamat)
                        setValue('top', supplier.payment)
                        getPenerimaan(supplier.id)
                    }

                    setListSupplier(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const getPenerimaan = (ids: any) => {
        Swal.fire({
            title: 'Now loading',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            }
        })

        const url = apiUrl.apiUrl + '/acc/invoice-receipt/get-penerimaan'
        axios
            .get(url, {
                params: { tgl_awal: tglAwal, tgl_akhir: tglAkhir, supplier_id: ids },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                    Swal.close()
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    interface FormInputs {
        sysdoctag_id: any
        supplier_id: any
        supplier_name: any
        alamat: any
        tgl: any
        tgl_nota: any
        no_nota: any
        no_faktur: any
        top: any
        tgl_jatuh_tempo: any
        kurir: any
        tagihan: any
        keterangan: any
        total_valas: any
        total: any
        total_valas_ppn: any
        total_ppn: any
        detail: any
        biayaLain: any
    }

    const defaultValues = {
        sysdoctag_id: 12602000007,
        tagihan: 0,
        top: 0,
        no_nota: '',
        no_faktur: '',
        keterangan: ''
    }

    // ** Hooks
    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })
    const watchedTagihan = watch('tagihan')

    const onSubmit = (data: any) => {
        if (!paidItems.length || !isTagihanValid) {
            document.getElementById('panduan-penyesuaian')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
            return
        }
        Swal.fire({
            title: 'Konfirmasi',
            html: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/acc/invoice-receipt/save'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/acc/invoice-receipt')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                html: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.response?.data?.message || error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    const handleTable = (row: any, value: any, name: any, mode: any) => {
        if (mode === 'pengurangan') {
            const index = listDataPengurangan.findIndex(o => o.accakun_id === row.accakun_id);
            const rowsInput = [...listDataPengurangan];
            rowsInput[index][name] = value;
            setListDataPengurangan(rowsInput);
        } else {
            const index = listDataPenambahan.findIndex(o => o.accakun_id === row.accakun_id);
            const rowsInput = [...listDataPenambahan];
            rowsInput[index][name] = value;
            setListDataPenambahan(rowsInput);
        }
    };

    const rowClick = (e: any) => {
        const item = e.data
        setValue('supplier_id', item.id)
        setValue('supplier_name', item.nama)
        setValue('alamat', item.alamat)
        setValue('top', item.payment)
        getPenerimaan(item.id)
        setOpenDialog(false)
    }

    const renderMaster = () => {
        return (
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Supplier
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='supplier_name'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => (
                                    <>
                                        <InputLabel htmlFor='input-file'>Supplier</InputLabel>
                                        <OutlinedInput
                                            label='Supplier'
                                            value={value}
                                            id='input-file'
                                            readOnly
                                            type={'text'}
                                            error={Boolean(errors.supplier_name)}
                                            startAdornment={
                                                <Box onClick={() => setOpenDialog(true)} style={{ cursor: 'pointer' }}>
                                                    <InputAdornment position='start'>
                                                        Cari &nbsp;
                                                        <IconButton edge='start' onMouseDown={e => e.preventDefault()} aria-label='search'>
                                                            <Icon fontSize={20} icon={'mdi:search'} />
                                                        </IconButton>
                                                    </InputAdornment>
                                                </Box>
                                            }
                                        />
                                    </>
                                )}
                            />
                            {errors.supplier_name && <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Alamat
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='alamat'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => (
                                    <TextField
                                        multiline
                                        rows={1}
                                        label='Alamat'
                                        error={Boolean(errors.alamat)}
                                        onChange={onChange}
                                        value={value}
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{
                                            readOnly: true
                                        }}
                                    />
                                )}
                            />
                            {errors.alamat && (
                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tanggal Nota
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tgl_nota'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Tanggal Nota'
                                            type='date'
                                            error={Boolean(errors.tgl_nota)}
                                            onChange={e => {
                                                onChange(e)
                                                // Hitung tgl_jatuh_tempo jika payment/top ada
                                                const top = getValues('top')
                                                const tglNota = e.target.value
                                                const jatuhTempo = moment(tglNota).add(Number(top), 'days').format('YYYY-MM-DD')
                                                setValue('tgl_jatuh_tempo', jatuhTempo)
                                            }}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.tgl_nota && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            No. Nota
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='no_nota'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='No. Nota'
                                            error={Boolean(errors.no_nota)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ min: 0 }}
                                        />
                                    )
                                }}
                            />
                            {errors.no_nota && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            No. Faktur
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='no_faktur'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='No. Faktur'
                                            type='number'
                                            error={Boolean(errors.no_faktur)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.no_faktur && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            TOP
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='top'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='TOP'
                                            type='number'
                                            error={Boolean(errors.top)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.top && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tanggal Jatuh Tempo
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tgl_jatuh_tempo'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Tanggal Jatuh Tempo'
                                            type='date'
                                            error={Boolean(errors.tgl_jatuh_tempo)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.tgl_jatuh_tempo && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Kurir
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='kurir'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Kurir'
                                            error={Boolean(errors.kurir)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.kurir && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tagihan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='tagihan'
                                control={control}
                                rules={{ required: true }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            fullWidth
                                            label='Tagihan'
                                            helperText='Isi total tagihan akhir sesuai nota supplier. Catat selisih terhadap GR pada bagian pengurangan atau penambahan di bawah.'
                                            name='tagihan'
                                            value={
                                                value !== undefined && value !== null && value !== ''
                                                    ? (() => {
                                                        // Format value for display: replace dot with comma, add thousand separator
                                                        const str = String(value).replace('.', ',')
                                                        const [integer, decimal] = str.split(',')
                                                        let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                        if (decimal !== undefined) {
                                                            formatted += ',' + decimal
                                                        }
                                                        return formatted
                                                    })()
                                                    : ''
                                            }
                                            onChange={e => {
                                                let input = e.target.value

                                                // Remove all except digits and comma
                                                input = input.replace(/[^0-9,]/g, '')

                                                // Split integer and decimal part
                                                const [intPart, decimalPart] = input.split(',')

                                                // Format integer part with thousand separator
                                                let formatted = ''
                                                if (intPart) {
                                                    const parsed = parseInt(intPart, 10)
                                                    formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                                }
                                                if (decimalPart !== undefined) {
                                                    formatted += ',' + decimalPart
                                                }

                                                // Raw value for backend: replace comma with dot
                                                const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                                setValue('tagihan', rawValue)
                                                setTagihan(rawValue)
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ inputMode: 'decimal' }}
                                        />
                                    )
                                }}
                            />
                            {errors.tagihan && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Tagihan Terbilang
                        </Typography>
                        <Typography variant='h5' sx={{ textTransform: 'uppercase' }}>
                            {tagihan == null ? (<>0</>) : (
                                <>
                                    {terbilang(tagihan)}
                                </>
                            )}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                            Keterangan
                        </Typography>
                        <FormControl fullWidth>
                            <Controller
                                name='keterangan'
                                control={control}
                                rules={{ required: false }}
                                render={({ field: { value, onChange } }) => {
                                    return (
                                        <TextField
                                            label='Keterangan'
                                            rows={2}
                                            multiline
                                            error={Boolean(errors.keterangan)}
                                            onChange={onChange}
                                            value={value}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    )
                                }}
                            />
                            {errors.keterangan && (
                                <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                    Form ini tidak boleh kosong.
                                </FormHelperText>
                            )}
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        )
    }

    const sumTotalValasPPN = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.TotalValasPPN) || 0 : 0), 0)
        : 0;

    const sumValas = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.Valas) || 0 : 0), 0)
        : 0;

    const sumTotal = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.Total) || 0 : 0), 0)
        : 0;

    const sumTotalPPN = listData.some(item => item.is_pay === 1)
        ? listData.reduce((acc, curr) => acc + (curr.is_pay === 1 ? Number(curr.TotalPPN) || 0 : 0), 0)
        : 0;

    const renderDetail = () => {
        return (
            <CardContent>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography variant='h6'>DAFTAR PENERIMAAN</Typography>
                        </Box>
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                label='Tanggal Awal'
                                type='date'
                                onChange={(e) => setTglAwal(e.target.value)}
                                value={tglAwal}
                                InputLabelProps={{ shrink: true }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={2} xs={12}>
                        <FormControl fullWidth>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </FormControl>
                    </Grid>
                    <Grid item sm={3} xs={12}>
                        <FormControl>
                            <Button
                                sx={{ marginTop: 1, width: 'auto' }}
                                variant='contained'
                                color='secondary'
                                startIcon={<Icon icon='mdi:magnify' />}
                                disabled={getValues('supplier_id') === undefined ? true : false}
                                onClick={() => getPenerimaan(getValues('supplier_id'))}
                            >
                                Cari Data
                            </Button>
                        </FormControl>
                    </Grid>
                </Grid>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Dibayar</TableCell>
                                <TableCell>ID PO</TableCell>
                                <TableCell>Tgl GR</TableCell>
                                <TableCell>No. Penerimaan</TableCell>
                                <TableCell>Surat Jalan</TableCell>
                                <TableCell>Keterangan</TableCell>
                                <TableCell>Total</TableCell>
                            </TableRow >
                        </TableHead >
                        <TableBody>
                            {listData.map((item, index) => {

                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <Checkbox
                                                checked={item.is_pay === 1}
                                                onChange={e => {
                                                    const updatedList = [...listData]
                                                    updatedList[index].is_pay = e.target.checked ? 1 : 0
                                                    setListData(updatedList)
                                                }}
                                                color="primary"
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <a
                                                href={'/purchasing/purchase-order/detail/' + item.pbpo_id}
                                                style={{ textDecoration: 'none' }}
                                                target='_blank'
                                            >
                                                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>{item.pbpo_id}</Typography>
                                            </a>
                                        </TableCell>
                                        <TableCell>{item.TanggalPenerimaan}</TableCell>
                                        <TableCell>
                                            <a
                                                href={'/purchasing/good-receipt/detail/' + item.NomorPenerimaan}
                                                style={{ textDecoration: 'none' }}
                                                target='_blank'
                                            >
                                                <Typography variant='body2' sx={{ fontWeight: 'bold' }}>{item.NomorPenerimaan}</Typography>
                                            </a>
                                        </TableCell>
                                        <TableCell>{item.NoSuratJln}</TableCell>
                                        <TableCell>{item.Keterangan}</TableCell>
                                        <TableCell sx={{ textAlign: 'right' }}>{formatNumber(item.Total)}</TableCell>
                                    </TableRow>
                                )
                            })}
                            <TableRow sx={{ backgroundColor: '#FFE995' }}>
                                <TableCell colSpan={6} sx={{ textAlign: 'right' }}><b>TOTAL :</b></TableCell>
                                <TableCell sx={{ textAlign: 'right' }}><b>{formatNumber(sumTotal)}</b></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table >
                </TableContainer >
            </CardContent >
        )
    }

    // TOTAL PENGURANGAN
    const totalPengurangan = listDataPengurangan.reduce(
        (acc, curr) => acc + (Number(curr.total) || 0),
        0
    )

    // TOTAL PENAMBAHAN
    const totalPenambahan = listDataPenambahan.reduce(
        (acc, curr) => acc + (Number(curr.total) || 0),
        0
    )

    const renderPengurangan = () => {
        return (
            <CardContent id='pengurangan-tagihan' sx={{ scrollMarginTop: 90 }}>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography variant='h6'>PENGURANGAN TAGIHAN</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Table key={1}>
                    <TableHead>
                        <TableRow>
                            <TableCell>PETUNJUK</TableCell>
                            <TableCell>TOTAL</TableCell>
                            <TableCell>KETERANGAN</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDataPengurangan.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.petunjuk}</TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label="Total"
                                        name="total"
                                        onChange={e => {
                                            let input = e.target.value

                                            // Hapus karakter selain angka dan koma
                                            input = input.replace(/[^0-9,]/g, '')

                                            // Pisahkan bagian integer dan desimal
                                            const [intPart, decimalPart] = input.split(',')

                                            // Format bagian integer (ribuan)
                                            let formatted = ''
                                            if (intPart) {
                                                const parsed = parseInt(intPart, 10)
                                                formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                            }

                                            if (decimalPart !== undefined) {
                                                formatted += ',' + decimalPart
                                            }

                                            // Raw value untuk backend: ganti koma ke titik
                                            const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                            // Kirim nilai mentah ke handler
                                            handleTable(item, rawValue, 'total', 'pengurangan')

                                            // Simpan formatted display ke item, kalau kamu pakai state management sendiri
                                            item.formatted_total = formatted
                                        }}
                                        value={
                                            item.formatted_total ??
                                            (item.total !== undefined && item.total !== null && item.total !== ''
                                                ? (() => {
                                                    const str = String(item.total).replace('.', ',')
                                                    const [integer, decimal] = str.split(',')
                                                    let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                    if (decimal !== undefined) {
                                                        formatted += ',' + decimal
                                                    }
                                                    return formatted
                                                })()
                                                : '')
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ inputMode: 'decimal' }} // pattern dihapus untuk hindari warning
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label='Keterangan'
                                        name='keterangan'
                                        rows={2}
                                        multiline
                                        onChange={e => {
                                            const val = e.target.value
                                            handleTable(item, val, 'keterangan', 'pengurangan')
                                        }}
                                        value={item.keterangan}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: '#FFE995' }}>
                            <TableCell><b>TOTAL</b></TableCell>
                            <TableCell><b>{formatNumber(totalPengurangan)}</b></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        )
    }

    const renderPenambahan = () => {
        return (
            <CardContent id='penambahan-tagihan' sx={{ scrollMarginTop: 90 }}>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}
                        >
                            <Typography variant='h6'>PENAMBAHAN TAGIHAN</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Table key={1}>
                    <TableHead>
                        <TableRow>
                            <TableCell>PETUNJUK</TableCell>
                            <TableCell>TOTAL</TableCell>
                            <TableCell>KETERANGAN</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listDataPenambahan.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell>{item.petunjuk}</TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label="Total"
                                        name="total"
                                        onChange={e => {
                                            let input = e.target.value

                                            // Hapus karakter selain angka dan koma
                                            input = input.replace(/[^0-9,]/g, '')

                                            // Pisahkan bagian integer dan desimal
                                            const [intPart, decimalPart] = input.split(',')

                                            // Format bagian integer (ribuan)
                                            let formatted = ''
                                            if (intPart) {
                                                const parsed = parseInt(intPart, 10)
                                                formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                            }

                                            if (decimalPart !== undefined) {
                                                formatted += ',' + decimalPart
                                            }

                                            // Raw value untuk backend: ganti koma ke titik
                                            const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                            // Kirim nilai mentah ke handler
                                            handleTable(item, rawValue, 'total', 'penambahan')

                                            // Simpan formatted display ke item, kalau kamu pakai state management sendiri
                                            item.formatted_total = formatted
                                        }}
                                        value={
                                            item.formatted_total ??
                                            (item.total !== undefined && item.total !== null && item.total !== ''
                                                ? (() => {
                                                    const str = String(item.total).replace('.', ',')
                                                    const [integer, decimal] = str.split(',')
                                                    let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                    if (decimal !== undefined) {
                                                        formatted += ',' + decimal
                                                    }
                                                    return formatted
                                                })()
                                                : '')
                                        }
                                        InputLabelProps={{ shrink: true }}
                                        inputProps={{ inputMode: 'decimal' }} // pattern dihapus untuk hindari warning
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        label='Keterangan'
                                        name='keterangan'
                                        rows={2}
                                        multiline
                                        onChange={e => {
                                            const val = e.target.value
                                            handleTable(item, val, 'keterangan', 'penambahan')
                                        }}
                                        value={item.keterangan}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow sx={{ backgroundColor: '#FFE995' }}>
                            <TableCell><b>TOTAL</b></TableCell>
                            <TableCell><b>{formatNumber(totalPenambahan)}</b></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </CardContent>
        )
    }

    const totalIncludePPN = sumTotalPPN
    const reconciliation = reconcileInvoice(totalIncludePPN, watchedTagihan || 0, listDataPenambahan, listDataPengurangan)
    const isTagihanValid = reconciliation.isValid && watchedTagihan !== '' && watchedTagihan != null
    const rupiah = (value: number) => `Rp ${Number(value).toLocaleString('id-ID', { maximumFractionDigits: 2 })}`

    const paidItems = listData.filter(item => item.is_pay === 1)

    useEffect(() => {
        getSupplier()

    }, [])

    useEffect(() => {
        if (totalPenambahan + totalPengurangan > 100000) {
            if (paidItems.some(item => item.is_gmpd === 1)) {
                setValue('sysdoctag_id', 12602000007)
            } else {
                setValue('sysdoctag_id', 12602000007)
            }
        } else {
            setValue('sysdoctag_id', 12602000007)
        }

    }, [totalPenambahan, totalPengurangan])

    useEffect(() => {
        setValue('total_valas_ppn', paidItems.length === 0 ? 0 : sumTotalValasPPN)
        setValue('total_valas', paidItems.length === 0 ? 0 : sumValas)
        setValue('total', paidItems.length === 0 ? 0 : sumTotal)
        setValue('total_ppn', paidItems.length === 0 ? 0 : sumTotalPPN)
        setValue('detail', JSON.stringify(paidItems))

        if (paidItems.length > 0) {
            // Cari tanggal paling akhir (paling muda) dari TanggalPenerimaan
            const latestDate = paidItems.reduce((max, curr) => {
                const currDate = new Date(curr.TanggalPenerimaan).getTime()
                return currDate > max ? currDate : max
            }, new Date(paidItems[0].TanggalPenerimaan).getTime())
            const latestDateStr = moment(latestDate).format('YYYY-MM-DD')
            setValue('tgl', latestDateStr)
            setTglDokumen(latestDateStr)
        } else {
            setValue('tgl', moment().format('YYYY-MM-DD'))
            setTglDokumen(moment().format('YYYY-MM-DD'))
        }

        setValue(
            'biayaLain', JSON.stringify([
                ...listDataPengurangan
                    .filter(item => Number(item.total) !== 0)
                    .map(item => ({ ...item, jenis: 'pengurangan' })),
                ...listDataPenambahan
                    .filter(item => Number(item.total) !== 0)
                    .map(item => ({ ...item, jenis: 'penambahan' }))
            ])
        )

    }, [
        sumTotalValasPPN,
        sumValas,
        sumTotal,
        sumTotalPPN,
        paidItems,
        listDataPengurangan,
        listDataPenambahan
    ])



    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Invoice Receipt
                    </Typography>
                    <Typography variant='body1' sx={{ textAlign: 'center', mb: 2 }}>
                        Tgl. Dokumen : <b>{moment(tglDokumen).format('LL')}</b>
                    </Typography>
                    <Divider />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {renderMaster()}
                        <Divider />
                        {renderDetail()}
                        <Box id='panduan-penyesuaian' sx={{ px: { xs: 1, sm: 3 }, py: 2, scrollMarginTop: 90 }}>
                            <Alert severity={!paidItems.length ? 'info' : isTagihanValid ? 'success' : 'warning'}>
                                <AlertTitle>{!paidItems.length ? 'Pilih penerimaan GR terlebih dahulu' : isTagihanValid ? 'Nilai tagihan sudah sesuai' : 'Petunjuk penyesuaian tagihan'}</AlertTitle>
                                <Typography variant='body2'>Total GR termasuk PPN <b>{rupiah(totalIncludePPN)}</b> + penambahan <b>{rupiah(reconciliation.addition)}</b> − pengurangan <b>{rupiah(reconciliation.deduction)}</b> = <b>{rupiah(reconciliation.expected)}</b>.</Typography>
                                <Typography variant='body2' sx={{ mt: 1 }}>Tagihan yang diisi: <b>{rupiah(Number(watchedTagihan || 0))}</b>.</Typography>
                                {paidItems.length > 0 && !isTagihanValid && <>
                                    <Typography variant='body2' sx={{ mt: 1 }}>Jika tidak ada penyesuaian lain, isi kolom <b>Tagihan</b> sebesar <b>{rupiah(reconciliation.expected)}</b> sesuai hasil perhitungan di atas.</Typography>
                                    <Typography variant='body2' sx={{ mt: 1 }}>Jika tagihan sesuai nota sudah benar dan selisihnya karena perubahan harga, buka <b>{reconciliation.section}</b> → baris <b>{reconciliation.label}</b> → kolom <b>Total</b>. Isi <b>{rupiah(reconciliation.suggested)}</b> (nilai saat ini {rupiah(reconciliation.current)} ditambah selisih {rupiah(Math.abs(reconciliation.difference))}). Nominal ini menggantikan isi kolom tersebut; kolom penyesuaian lainnya tetap.</Typography>
                                    <Button type='button' size='small' variant='outlined' sx={{ mt: 1.5 }} onClick={() => {
                                        const section = document.getElementById(reconciliation.anchor)
                                        section?.scrollIntoView({ behavior: 'smooth', block: 'center' })
                                        section?.querySelector<HTMLInputElement>('input[name="total"]')?.focus({ preventScroll: true })
                                    }}>Ke kolom {reconciliation.label}</Button>
                                </>}
                                <Typography variant='body2' sx={{ mt: 1 }}>Untuk diskon, gunakan baris DISKON PEMBELIAN; untuk ongkir, gunakan JASA ANGKUTAN. Isi nominal positif dan jelaskan penyebabnya di Keterangan. Pembayaran sebagian tidak mengubah total tagihan invoice.</Typography>
                            </Alert>
                        </Box>
                        {renderPengurangan()}
                        {renderPenambahan()}
                        {isTagihanValid && paidItems.length > 0 ? (
                            <Box
                                sx={{
                                    width: '100%',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mb: 4 }}>
                                    <Button variant='contained' type='submit'>
                                        SIMPAN
                                    </Button>
                                </Box>
                            </Box>
                        ) : (
                            <Alert severity='error' sx={{ width: '100%' }}>
                                <AlertTitle>{paidItems.length ? 'Tagihan belum sesuai' : 'Belum ada GR yang dipilih'}</AlertTitle>
                                {paidItems.length ? `Selisih ${rupiah(Math.abs(reconciliation.difference))}. Ikuti petunjuk penyesuaian di atas sebelum menyimpan.` : 'Pilih minimal satu penerimaan GR untuk membuat invoice receipt.'}
                            </Alert>
                        )}
                    </form>
                </div>
            </Grid>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
            >
                <DialogTitle id='form-dialog-title'>Pilih Supplier</DialogTitle>
                <DialogContent>
                    <MsiDatagrid array={listSupplier} rowClick={rowClick} />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button
                        onClick={() => setOpenDialog(false)}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}

export default Add
